/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
/* eslint-disable camelcase */

export const columns = (eventId: number | string): [] => [
  {
    selector: 'is_disabled',
    name: 'on/off',
    sortable: false,
    maxWidth: '100px',
    cell: (row: {}): React.Element<'div'> => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Switcher
          className='form-switcher-sm'
          id={row.group_id}
          name={row.group_id.toString()}
          index={row.group_id}
          checked={!row.is_disabled}
          onCallback={async (e: any, newStatus: boolean) => {
            CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);

            try {
              // TODO Change to VIP endpoint
              await PUT(`/api/v1/1/vipcodes/${eventId}/${row.group_id}/${newStatus ? 'enable' : 'disable'}`);

              CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
            } catch (error) {
              CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
            }
          }}
        />
      </div>
    )
  },
  {
    selector: 'codes',
    name: 'VIP Code',
    sortable: false,
    style: {
      minWidth: '200px',
      padding: '10px 16px'
    },
    cell: (row: {}): string =>  row.codes ? row.codes.join(', ') : ''
  },
  {
    selector: 'applies',
    name: 'Applies to',
    sortable: false,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      overflow: 'visible'
    },
    cell: (row: {}): React.Element<'div'> => {
      const appliedTickets = row.applied_to_tickets;

      if (row.applied_to_all_tickets) {
        return 'All tickets';
      } else if (_.size(appliedTickets) > 1) {
        return (
          <span data-tip={appliedTickets.join(',<br/>')} style={{ color: 'blue' }}>
              {_.size(appliedTickets)} Tickets
          </span>
        );
      } else if (_.size(appliedTickets) === 1) {
        return (<span>{appliedTickets[0]}</span>);
      }
    }
  }
];
